import { 
  Sword, Shield, Users, BookOpen, Star, Calendar, 
  Lightbulb, Heart, CheckCircle 
} from "lucide-react";

const inclusions = [
  { icon: Sword, text: "Five fun, structured fencing sessions" },
  { icon: Shield, text: "All equipment provided" },
  { icon: Users, text: "Fully qualified, DBS-checked coaches" },
  { icon: Heart, text: "A welcoming, inclusive environment" },
  { icon: BookOpen, text: "A Masky Fencing Passport to track progress" },
  { icon: Star, text: "Stickers and skill achievements" },
  { icon: Calendar, text: "Flexible use across school holidays for 12 months" },
  { icon: CheckCircle, text: "Childcare vouchers & Tax-Free Childcare accepted" },
  { icon: Lightbulb, text: "Masky's special tips and encouragement" },
];

export default function WhatsIncludedSection() {
  return (
    <section
      id="whats-included"
      className="py-20 bg-[#F4F4F4]"
      data-testid="whats-included-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <div className="inline-flex items-center gap-2 bg-[#D4A857]/10 text-[#D4A857] px-4 py-2 rounded text-sm font-bold uppercase tracking-wide mb-4 font-['Montserrat']">
              <CheckCircle size={16} />
              Everything You Need
            </div>
            
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0A1A2F] mb-6 font-['Montserrat']">
              What's <span className="text-[#D4A857]">Included</span>
            </h2>
            
            <p className="text-lg text-gray-600 mb-8 font-['Lato']">
              One pass, everything included. No hidden costs, no extra equipment to buy. 
              Just show up and let the adventure begin!
            </p>

            {/* Inclusions Grid */}
            <div className="grid sm:grid-cols-2 gap-4">
              {inclusions.map((item, i) => (
                <div
                  key={i}
                  className="flex items-center gap-3 bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-all border border-[#F4F4F4]"
                  data-testid={`inclusion-${i}`}
                >
                  <div className="w-10 h-10 bg-[#0A1A2F]/10 rounded-lg flex items-center justify-center text-[#0A1A2F] flex-shrink-0">
                    <item.icon size={20} />
                  </div>
                  <p className="text-[#0A1A2F] font-medium text-sm font-['Lato']">{item.text}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Visual */}
          <div className="relative">
            <div className="bg-[#0A1A2F] rounded-lg p-8 text-white">
              {/* Masky - Small */}
              <div className="text-center mb-6">
                <img
                  src="https://customer-assets.emergentagent.com/job_1abea0ec-cded-4678-a29f-de28c813ea65/artifacts/2pfnnew9_bigger%20masky.png"
                  alt="Masky giving thumbs up"
                  className="w-40 mx-auto masky-glow"
                />
              </div>
              
              <div className="bg-white/10 rounded-lg p-6 backdrop-blur-sm">
                <p className="font-bold text-[#D4A857] mb-3 text-center font-['Montserrat'] uppercase text-sm">Masky's Top Tip!</p>
                <p className="text-white/90 text-center leading-relaxed font-['Lato']">
                  "Don't worry about bringing any equipment — we've got everything you need! 
                  Just bring yourself, some energy, and a big smile."
                </p>
              </div>
              
              {/* Value Highlight */}
              <div className="mt-6 text-center">
                <p className="text-[#D4A857] text-sm uppercase tracking-wide mb-1 font-['Montserrat']">Incredible Value</p>
                <p className="text-4xl font-extrabold font-['Montserrat']">5 Full Days</p>
                <p className="text-white/70 font-['Lato']">of fencing fun & learning</p>
              </div>
            </div>
            
            {/* Floating Badge */}
            <div className="absolute -top-4 -right-4 bg-[#D4A857] text-[#0A1A2F] px-5 py-3 rounded-lg shadow-lg font-bold font-['Montserrat']">
              All Equipment<br/>
              <span className="text-sm font-normal">Provided!</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
